interface Store {
  config: any;
  state: {
    start: string;
    end: string;
  };
}

export class SelectInput {
  public node: HTMLInputElement;
  private store: Store;
  private type: 'start' | 'end';
  private freeInputRadio: HTMLInputElement | null;
  private activeClassName: string;

  constructor({
    node,
    store,
    type,
    inactiveSelectNodes,
    freeInputRadio,
  }: {
    node: HTMLInputElement;
    store: Store;
    type: 'start' | 'end';
    inactiveSelectNodes: () => void;
    freeInputRadio: HTMLInputElement | null;
  }) {
    this.node = node;
    this.store = store;
    this.type = type;
    this.freeInputRadio = freeInputRadio;
    this.activeClassName = store.config.className.activeSelectBtn;

    this.node.addEventListener('input', () => {
      if (this.freeInputRadio) {
        this.freeInputRadio.checked = true;
      }

      inactiveSelectNodes();

      this.node.classList.add(this.activeClassName);

      if (this.freeInputRadio?.checked) {
        this.store.state[this.type] = this.node.value;
      }
    });
  }
}
